import React from "react"
import { getCssSizeValue } from "@/utils/utils"
import styled from "styled-components"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Background = styled.div`
	position: absolute;
	z-index: 0;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	background-color: ${({ theme }) => theme.colors.white};
	display: grid;
	padding: ${getCssSizeValue(6, BREAKPOINTS.MOBILE)};
	grid-gap: ${getCssSizeValue(11, BREAKPOINTS.MOBILE)};
	grid-template-columns: repeat(${({ $columns }) => $columns}, 1fr);
	grid-template-rows: repeat(${({ $rows }) => $rows}, 1fr);
	overflow: hidden;

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(16)};
		grid-gap: ${getCssSizeValue(16)};
	}
`

const Square = styled.div`
	--size: ${getCssSizeValue(30, BREAKPOINTS.MOBILE)};
	width: var(--size);
	height: var(--size);
	background-color: ${({ theme }) => theme.colors.antiflashWhite};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		--size: ${getCssSizeValue(45)};
	}
`

export default function SquaresBackground({ rows = 4, columns = 16 }) {
	return (
		<Background className="bg" $rows={rows} $columns={columns}>
			{[...new Array(rows * columns)].map((_, key) => (
				<Square key={`block-${key}`} />
			))}
		</Background>
	)
}
